import { ManagementReportExecutionRepository } from '@domain/management-report-execution/repositories/management-report-execution.repository';
import { ManagementReportExecutionRepositoryService } from '../repositories/management-report-execution.service';

export const ManagementReportExecutionProvider = [
  {
    provide: ManagementReportExecutionRepository,
    useClass: ManagementReportExecutionRepositoryService,
  },
];
